import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import {
    deformationArrowsEnabledState,
    deformationGridEnabledState,
} from '~/state/atoms/deformationDisplayAtoms';

export function useDeformationDisplayScope(active: boolean): void {
    const setArrows = useSetRecoilState(deformationArrowsEnabledState);
    const setGrid = useSetRecoilState(deformationGridEnabledState);

    useEffect(() => {
        if (active) {
            return;
        }
        setArrows(false);
        setGrid(false);
    }, [active, setArrows, setGrid]);

    useEffect(
        () => () => {
            setArrows(false);
            setGrid(false);
        },
        [setArrows, setGrid]
    );
}
